var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "E99FF65D-D892-44F4-B88A-A9ED9E16D4E7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 1660,
    height: 1010
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-3",
    x: 0,
    y: 0,
    width: 1100,
    height: 990
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-5",
    x: 0,
    y: 0,
    width: 1100,
    height: 260
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8288777,8.11857422 L21.718042,0.176835937 C21.6025718,0.0638671875 21.4432639,0 21.2768674,0 L9.18824695,0 C7.83537356,0 6.73470657,1.03675781 6.73470657,2.31105469 L6.73470657,10.3846289 L1.83564716,10.3846289 C0.823463817,10.3846289 0,11.1603516 0,12.1139062 L0,20.7707812 C0,21.7242773 0.823463817,22.5 1.83564716,22.5 L6.73470657,22.5 L6.73470657,27.6929883 C6.73470657,28.9650586 7.83537356,30 9.18824695,30 L27.5464596,30 C28.899333,30 30,28.9656445 30,27.6942773 L30,8.51865234 C30,8.36947266 29.9386273,8.22609375 29.8288777,8.11857422 Z M21.4285892,1.55748047 L28.0868752,8.07691406 L21.4285892,8.07691406 L21.4285892,1.55748047 Z M20.2040575,1.15382813 L20.2040575,8.65382813 C20.2040575,8.97246094 20.4782138,9.23074219 20.8162923,9.23074219 L28.7754683,9.23074219 L28.7754683,27.6942773 C28.7754683,28.3294336 28.2241088,28.8461719 27.5463974,28.8461719 L9.18824695,28.8461719 C8.51053554,28.8461719 7.95917606,28.3289063 7.95917606,27.6930469 L7.95917606,22.5 L18.3684725,22.5 C19.3806559,22.5 20.2041197,21.7242773 20.2041197,20.7707813 L20.2041197,12.1139063 C20.2041197,11.1603516 19.3806559,10.3846289 18.3684725,10.3846289 L7.95917606,10.3846289 L7.95917606,2.31105469 C7.95917606,1.67291016 8.51053554,1.15382813 9.18824695,1.15382813 L20.2040575,1.15382813 Z M10.0854718,14.25 C10.7989921,14.25 11.3674075,14.4611465 11.7907351,14.8834459 C12.2140627,15.3057454 12.4257233,15.8728246 12.4257233,16.5847008 C12.4257233,17.3126645 12.2140627,17.886782 11.7907351,18.3070705 C11.3674075,18.7273589 10.7885911,18.9375 10.0542685,18.9375 C9.35322962,18.9375 8.79261497,18.7243425 8.37240771,18.2980212 C7.95220045,17.8716999 7.74209997,17.3036152 7.74209997,16.59375 C7.74209997,15.875841 7.95324055,15.3057454 8.37552805,14.8834459 C8.79781554,14.4611465 9.3677911,14.25 10.0854718,14.25 Z M15.4618096,14.25 C15.9652263,14.25 16.465515,14.3073112 16.9626909,14.4219353 L16.9626909,15.14889 C16.3989475,14.9578498 15.9267415,14.8623311 15.5460587,14.8623311 C15.0592839,14.8623311 14.6838073,15.0116418 14.4196176,15.3102679 C14.1554279,15.6088939 14.023335,16.0326951 14.023335,16.5816844 C14.023335,17.1206188 14.1653089,17.540901 14.4492608,17.8425434 C14.7332127,18.1441859 15.1279312,18.2950048 15.6334281,18.2950048 C16.0869191,18.2950048 16.5445637,18.1844043 17.0063756,17.9631998 L17.0063756,18.6479247 C16.5591253,18.8409759 16.0255533,18.9375 15.4056436,18.9375 C14.6484384,18.9375 14.0587009,18.7313808 13.6364135,18.3191361 C13.214126,17.9068914 13.0029854,17.3317685 13.0029854,16.59375 C13.0029854,15.8416549 13.2156861,15.2630128 13.641094,14.8578065 C14.0665018,14.4526001 14.673401,14.25 15.4618096,14.25 Z M4.94939983,14.3616071 C5.66500032,14.3616071 6.21313374,14.5451035 6.59381656,14.9121018 C6.97449938,15.2791001 7.16483793,15.8084747 7.16483793,16.5002413 C7.16483793,17.2362489 6.96305826,17.8078527 6.55949287,18.21507 C6.15592748,18.6222873 5.59115243,18.8258929 4.86515078,18.8258929 L2.96174621,18.8258929 L2.96174621,14.3616071 L4.94939983,14.3616071 Z M10.0854718,14.8623311 C9.68398666,14.8623311 9.36311539,15.0191828 9.12284836,15.3328909 C8.88258134,15.6465991 8.76244963,16.0658758 8.76244963,16.5907336 C8.76244963,17.1115695 8.88206129,17.5303435 9.1212882,17.8470681 C9.3605151,18.1637926 9.67566582,18.3221525 10.0667498,18.3221525 C10.4786361,18.3221525 10.8047079,18.1658035 11.0449749,17.8531009 C11.285242,17.5403982 11.4053737,17.1165969 11.4053737,16.5816844 C11.4053737,16.0628594 11.2847219,15.6465991 11.0434148,15.3328909 C10.8021076,15.0191828 10.4827965,14.8623311 10.0854718,14.8623311 Z M4.50319187,14.9739382 L3.9228095,14.9739382 L3.9228095,18.1924469 L4.64048663,18.1924469 C5.14598348,18.1924469 5.52302024,18.0572126 5.77160819,17.7867399 C6.02019615,17.5162671 6.14448827,17.1055369 6.14448827,16.5545367 C6.14448827,16.1282154 6.04463854,15.7732881 5.84493608,15.4897442 C5.70764063,15.2946821 5.54226451,15.1599505 5.34880275,15.0855454 C5.155341,15.0111402 4.87347352,14.9739382 4.50319187,14.9739382 Z",
    id: "path-7"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Furniture-/-3.1_Retailer_Profile_01",
    transform: "translate(-270.000000, -1435.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Wrapper",
    fill: "#F6F7FA"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u25A0-Shape",
    x: 0,
    y: 0,
    width: 1920,
    height: 1660
  })), /*#__PURE__*/React.createElement("g", {
    id: "Conteainer",
    transform: "translate(220.000000, 60.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Shadow",
    x: 0,
    y: 0,
    width: 1700,
    height: 1380
  }), /*#__PURE__*/React.createElement("g", {
    id: "Backgorund",
    transform: "translate(1.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u25A0-Shape",
    x: 0,
    y: 0,
    width: 1700,
    height: 1380
  })), /*#__PURE__*/React.createElement("g", {
    id: "Content",
    transform: "translate(20.000000, 90.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 500.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Bound"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Block_Left",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Bound"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 650.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Bound",
    stroke: "none",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    mask: "url(#mask-6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 100.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bound",
    fill: "#F7F7F7",
    x: 0,
    y: 0,
    width: 520,
    height: 60
  }), /*#__PURE__*/React.createElement("g", {
    id: "ic_pdf",
    transform: "translate(10.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ic_file_doc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Color",
    mask: "url(#mask-8)",
    fill: "#04B0ED"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u25A0-Color",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }))))))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.d01ba7d8671e170ddfdeba47fc5befd1.svg";
export { ForwardRef as ReactComponent };